import { render, staticRenderFns } from "./ProtocolAdd.vue?vue&type=template&id=9701eacc&"
import script from "./ProtocolAdd.vue?vue&type=script&lang=js&"
export * from "./ProtocolAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports